<div class="flex items-center justify-center p-6 bg-[#f7f8fa] w-screen" id="wrapper">

  <div class="flex flex-col gap-6 bg-white shadow-md rounded-md p-4 w-full max-w-2xl">
    <div class="flex gap-2">
      <div *ngIf="isFullyLoaded" class="flex items-center rounded overflow-hidden justify-center w-9 h-9 min-w-9 ">
        <img src="{{company?.logo}}" onerror="this.src='assets/images/edozzier-logo.png'" class="h-full " />
      </div>
      <div *ngIf="!isFullyLoaded" class="rounded w-9 h-9 min-w-9 bg-slate-200 animate-pulse"> </div>

      <div class="flex flex-col -space-y-1">
        <p *ngIf="isFullyLoaded" class="font-medium hidden sm:block uppercase">{{company?.name}}</p>
        <p *ngIf="isFullyLoaded" class="font-medium md:hidden uppercase">{{company?.adm_initial}}</p>
        <p *ngIf="!isFullyLoaded" class="h-3.5 rounded-md bg-slate-200 mb-2 w-48 animate-pulse"></p>
        <span class="text-xs text-gr900">Student Portal</span>
      </div>
    </div>

    <div class="flex flex-col">
      <h3 class="font-medium text-xl">Login to your account</h3>
      <p class="text-sm text-ndgray">Please enter your details to sign in</p>
    </div>

    <div *ngIf="errorMessagee"
      class="flex rounded-md gap-2 bg-red-50 items-center border-[1px] border-red-100 text-red-800 p-3">
      <i class="bx bx-error"></i>
      <p class="text-sm">{{errorMessagee}}</p>
    </div>

    <form (submit)="loginHandler($event)" class="flex flex-col gap-4">
      <div class="flex flex-col">
        <label class="text-xs font-medium text-ndgray" for="usr">Student ID</label>
        <div
          class="border-[1px] px-2 focus-within:border-gr400 rounded-md overflow-hidden transition-all duration-300 text-gr400 focus-visible:text-gray-800 h-11 flex items-center gap-2">
          <i class="bx bx-id-card text-lg w-5"></i>
          <input type="text" id="usr" class="w-full text-sm outline-none h-full text-gr900">
        </div>
      </div>

      <div class="flex flex-col">
        <label class="text-xs font-medium text-ndgray" for="pass">Password</label>
        <div class="input-container">
          <i class="bx bx-lock-alt text-lg w-5"></i>
          <input [type]="showPassword ? 'text' : 'password'" id="pass" class="custom-input">
          <button (click)="showPassword = !showPassword" type="button"
            class="h-8 text-gray-500 flex items-center justify-center w-8 rounded">
            <i class="bx bx-show text-lg" *ngIf="showPassword"></i>
            <i class="bx bx-hide text-lg" *ngIf="!showPassword"></i>
          </button>
        </div>
      </div>

      <p class="flex justify-end"><a class="text-xs" routerLink="/forgot-password">Reset Password</a></p>

      <button [disabled]="flag" type="submit" id="login"
        class="h-11 disabled:opacity-70 text-sm text-white bg-primary1 rounded-md p-2">
        <span>{{flag ? 'Signing in...' : 'Sign In'}}</span>
      </button>

      <div class="text-xs mt-2 text-gray-700 items-center gap-2 flex justify-center">
        Powered By
        <!-- <a target="_blank" href="https://edozzier.com/"> -->
        <img src=" assets/images/edozzier-log.png" class="h-4 inline rm-drag" />
        <!-- </a> -->
      </div>
    </form>
  </div>


</div>